<template>
  <v-menu offset-y>
    <v-btn slot="activator" icon flat :title="$t('Pilot.MissionConsole.GdbFilter')" ><v-icon >mdi-filter</v-icon></v-btn>
    <div class="white">
      <div class="d-flex">
        <v-btn small @click.stop="$store.myActions.UI_SET_GDB_CONSOLE_FILTER({gdbTypes:accesModConfFilter?[]:['GliderInfoModEvent','GliderInfoModConf'],uiid})" color="primary">{{$t('Pilot.MissionConsole.ShowAll')}}
          <v-icon small class="pl-2">mdi-eye</v-icon>
        </v-btn>
        <v-btn class="pl-2" small @click.stop="$store.myActions.UI_SET_GDB_CONSOLE_FILTER({gdbTypes:[...gdbTypes],uiid})" color="primary">{{$t('Pilot.MissionConsole.HideAll')}}
          <v-icon small class="pl-2">mdi-eye-off</v-icon>
        </v-btn>                                
      </div>
      <div class="grid" >
        <div v-for="gdbType in gdbTypes" :key="gdbType" 
          class="cursor-pointer no-wrap"      
          :class="{'red--text':missionState.consoleGdbFilter.some(f => f == gdbType)}"         
          @click.stop="$store.myActions.UI_TOGGLE_GDB_CONSOLE_FILTER({gdbType,uiid})">
          <v-icon class="mr-2" :class="{'red--text':missionState.consoleGdbFilter.some(f => f == gdbType)}" v-text="missionState.consoleGdbFilter.some(f => f == gdbType)?'mdi-eye-off':'mdi-eye'" />
          {{$t(`WobGbdType.${gdbType}`)}}
        </div>
      </div>    
    </div>
  </v-menu> 
</template>
<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import { WobGbdType } from '@/enum/WobGbdType';
  import { MissionUiState, buildMissionUIStateId } from '@/models/ui/MissionUiState';
  import { SecurityItemsKeys } from '@/enum/SecurityItems';
  import { AloMission } from '@/models/alo/AloMission'

  @Component({
    name: 'MissionDetailConsoleFilter',
    props: {
      mission: {
        type: AloMission,
        required: true
      }
    }
  })
  export default class MissionDetailConsoleFilter extends Vue { 
    
    mission!: AloMission

    get gdbTypes(){
      return Object.values(WobGbdType).filter(f => this.accesModConfFilter || (f != WobGbdType.GliderInfoModEvent && f != WobGbdType.GliderInfoModConf))
    } 
     
    get accesModConfFilter() {
        return this.$store.myGetters.userSecurity[SecurityItemsKeys.PILOT_DETAIL_COMMAND_CONSOLE_MOD_CONF_FILTER]
    }   

    get uiid()  {
        return buildMissionUIStateId(this.mission.misId!,'detail')
    }
    
    get missionState() {                  
      return this.$store.myGetters.uistatebyuiid(this.uiid) as MissionUiState
    }
      
  }
</script>

<style scoped>

.grid{  
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  user-select: none;
}

</style>
